// Caminho-base secreto do painel administrativo.
//
// Segurança: o caminho óbvio "/admin" é propositadamente inexistente e devolve
// 404 (página não encontrada). Isto reduz a superfície de ataque, dificultando
// a enumeração do painel e ataques automáticos de bruteforce ao login.
//
// Para alterar o caminho de acesso, muda APENAS esta constante.
export const ADMIN_BASE = '/evo860';

// Constrói um caminho absoluto dentro do painel a partir de um sub-caminho.
// adminPath('login') -> '/evo860/login'
// adminPath('/core/users') -> '/evo860/core/users'
export const adminPath = (sub = '') => {
  const clean = String(sub).replace(/^\/+/, '');
  return clean ? `${ADMIN_BASE}/${clean}` : ADMIN_BASE;
};
